import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useKillSwitchFlagsStore = defineStore('killSwitchFlags', () => {
    const appDisabled = ref(null);
    const getAppDisabled = computed(() => appDisabled.value);

    const dashboardDisabled = ref(null);
    const getDashboardDisabled = computed(() => dashboardDisabled.value);

    const documentsDisabled = ref(null);
    const getDocumentsDisabled = computed(() => documentsDisabled.value);

    function $reset() {
        appDisabled.value = false;
        dashboardDisabled.value = false;
        documentsDisabled.value = false;
    }

    return {
        $reset,
        appDisabled,
        getAppDisabled,
        dashboardDisabled,
        getDashboardDisabled,
        documentsDisabled,
        getDocumentsDisabled
    }
}, { persist: true })